import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

// Response interceptor — 401 => logout
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ==================== AUTH ====================
export const authAPI = {
  login: (data) => api.post('/auth/login/', data),
  logout: () => api.post('/auth/logout/'),
  me: () => api.get('/auth/me/'),
  register: (data) => api.post('/devices/parent/register/', data),
  telegramStatus: () => api.get('/auth/telegram/status/'),
  telegramLink: () => api.post('/auth/telegram/link/'),
  telegramUnlink: () => api.post('/auth/telegram/unlink/'),
};

// ==================== ADMIN: DEVICES ====================
export const devicesAPI = {
  list: (params) => api.get('/devices/', { params }),
  get: (id) => api.get(`/devices/${id}/`),
  create: (data) => api.post('/devices/', data),
  update: (id, data) => api.patch(`/devices/${id}/`, data),
  delete: (id) => api.delete(`/devices/${id}/`),
  stats: () => api.get('/devices/stats/'),
  regenerateCode: (id) => api.post(`/devices/${id}/regenerate_code/`),
};

// ==================== PARENT: DEVICES ====================
export const parentDeviceAPI = {
  list: () => api.get('/devices/parent/devices/'),
  get: (id) => api.get(`/devices/parent/devices/${id}/`),
  locations: (id, params) => api.get(`/devices/parent/devices/${id}/locations/`, { params }),
  remove: (id) => api.post(`/devices/parent/devices/${id}/remove/`),
  activate: (data) => api.post('/devices/parent/activate/', data),
};

// ==================== PARENT: CHILDREN ====================
export const childAPI = {
  list: () => api.get('/devices/parent/children/'),
  get: (id) => api.get(`/devices/parent/children/${id}/`),
  create: (data) => api.post('/devices/parent/children/create/', data),
  update: (id, data) => api.patch(`/devices/parent/children/${id}/update/`, data),
  delete: (id) => api.delete(`/devices/parent/children/${id}/delete/`),
};

// ==================== PARENT: ZONES ====================
export const zoneAPI = {
  list: () => api.get('/devices/parent/zones/'),
  get: (id) => api.get(`/devices/parent/zones/${id}/`),
  create: (data) => api.post('/devices/parent/zones/', data),
  update: (id, data) => api.put(`/devices/parent/zones/${id}/`, data),
  delete: (id) => api.delete(`/devices/parent/zones/${id}/`),
};

// ==================== PARENT: RELATIVES ====================
export const relativeAPI = {
  list: () => api.get('/devices/parent/relatives/'),
  get: (id) => api.get(`/devices/parent/relatives/${id}/`),
  create: (data) => api.post('/devices/parent/relatives/', data),
  update: (id, data) => api.put(`/devices/parent/relatives/${id}/`, data),
  delete: (id) => api.delete(`/devices/parent/relatives/${id}/`),
};

// ==================== PARENT: SUBSCRIPTION ====================
export const subscriptionAPI = {
  get: (deviceId) => api.get(`/devices/parent/devices/${deviceId}/subscription/`),
  subscribe: (deviceId, data) => api.post(`/devices/parent/devices/${deviceId}/subscribe/`, data),
  payments: () => api.get('/devices/parent/payments/'),
};

// ==================== PARENT: LOGS ====================
export const logsAPI = {
  list: (deviceId, params) => api.get(`/devices/parent/devices/${deviceId}/logs/`, { params }),
  signalLosses: (deviceId, params) => api.get(`/devices/parent/devices/${deviceId}/signal-losses/`, { params }),
  report: (deviceId, params) => api.get(`/devices/parent/devices/${deviceId}/report/`, { params }),
};

// ==================== PARENT: NOTIFICATIONS ====================
export const notificationAPI = {
  get: (deviceId) => api.get(`/devices/parent/devices/${deviceId}/notifications/`),
  update: (deviceId, data) => api.patch(`/devices/parent/devices/${deviceId}/notifications/`, data),
};

export default api;
